import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: 'Estudiás horas y en el examen te quedás en blanco',
  desc: 'Leés y subrayás todo, pero a la hora de rendir sentís que te olvidaste de lo que estudiaste.'
}, {
  title: 'Recursás materias que "creías que tenías"',
  desc: 'Te quedás a un punto del aprobado y no entendés por qué, si dedicaste semanas enteras a prepararte.'
}, {
  title: 'El pánico te paraliza en los finales orales',
  desc: 'Sabés el tema pero frente al tribunal las palabras no salen y el docente lo nota inmediatamente.'
}, {
  title: 'Llegás tarde a preparar siempre',
  desc: 'El cuatrimestre pasa volando y de repente tenés 5 parciales en una semana sin haber empezado ninguno.'
}, {
  title: 'Dependés de los apuntes de otros',
  desc: 'Si no aparece alguien que ya rindió, no sabés por dónde empezar ni qué es realmente importante.'
}, {
  title: 'Terminás agotado y el próximo arrancás igual',
  desc: 'Sos esclavo de las fotocopias y los finales amontonados, no dueño de tu rendimiento académico.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="bg-ink-2 border-y border-white/5" data-id="element-108" data-mp="1u0sp0t5b8419">
      <div className="mx-auto max-w-4xl px-5 py-20 pt-[5px] pb-[0px]" data-id="element-109" data-mp="27t8ltc7mb5tq">
        <h2 className="text-center font-display font-black text-white sm:text-4xl pt-[24px] text-[25px]" data-id="element-110" data-mp="23rna3u6tkxl4">
          ❌ ¿Cuántas materias más vas a recursar así?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-111" data-mp="1g3x1jvobaa1o">
          Sos estudiante universitario. Querés aprobar. Pero nadie te dijo que ibas a pasar los días
          leyendo sin entender, sufriendo bloqueos en el examen y llegando a fin de cuatrimestre sin
          saber qué fallaste.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-verde-soft" data-id="element-112" data-mp="30h4lmpshhduq">
          No es falta de inteligencia. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-113" data-mp="1t5oi4vgv83w9">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-114" data-mp="1y48611f0rpr9" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-verde/20 text-verde-soft" data-id="element-115" data-mp="1ackmx5o01izj">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-116" data-mp="1jfloct1x6lwv" />
              </span>
              <div data-id="element-117" data-mp="1o624ikx4klmx">
                <h3 className="text-sm font-bold text-white" data-id="element-118" data-mp="1o6loe76c5k3l">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-119" data-mp="1o7wnvusr05ow">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 pb-12 text-center" data-id="element-120" data-mp="vops9jqfl4jt">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-121" data-mp="vnepnn8q22ua">
            ¿Y si este fuera el último cuatrimestre que arrancás sin un método real?
          </p>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-122" data-mp="j7ygkiyexovq">
            El próximo parcial puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}